import form from './form';
import register from './register';
import pages from "./pages";
import apps_sidebar from "./apps_sidebar";
import components from './components';

export default {
    form,
    register,
    offline_mode: {
        online: 'Vous êtes à nouveau en ligne.',
        offline: "Nous n'arrivons plus à detecter votre connexion internet.",
        banner: {
            text: "Attention, votre connexion internet semble rencontrer un problème.",
        },
    },
    pagination: {
        prev: '<',
        next: '>'
    },
    table: {
        empty: "Aucun élément pour l'instant."
    },
    misc: {
        confirm_page_leave: 'Êtes-vous sûr de vouloir quitter cette page ? Vos modificactions seront perdues.',
        confirm: 'Êtes-vous sûr de vouloir continuer ?',
        back_button: 'Retour',
        date_time: "Le {date} à {time}"
    },
    apps_sidebar: {
        account: 'Mon compte',
        help: 'Aide'
    },
    help_submenu: {
        label: 'Aide',
        help: {
            link: 'https://pro.trustup.be/aide',
            text: "Centre d'aide",
        },
        support: {
            link: 'https://pro.trustup.be/support/',
            text: "Contacter le support",
        },
        chat: {
            text: "Chat",
        }
    },
    components,
    pages,
    apps_sidebar
}